export const getProfileRouteForRole = (role: string): string => {
    return '/vendor-dashboard-preview';
};

